import { useRef, useState, useEffect } from "react";
import LoadingSpinner from "../../components/Controls/LoadingSpinner/LoadingSpinner";
import "../../components/Pages/Code/Code.css";
export default function PersonalInfo({ documentId, rpdInfo }) {
  const [openLoader, setOpenLoader] = useState(false);
  const [personalInfoText, setReader_PersonalInfoText] = useState("");
  const [firstNameText, setReader_FirstNameText] = useState("");
  const [lastNameText, setReader_LastNameText] = useState("");
  const [continueText, setReader_ContinueText] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [NavigatingBnPagesPleaseWait, setReader_NavigatingBnPagesPleaseWait] =
    useState("");
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  useEffect(() => {
    getLanguageTranslations();
  }, []);
  async function getLanguageTranslations() {
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
    let json;
    try {
      var res = await fetch(url);
      json = await res.json();
      console.log(json);
      //setLanguageTranslations(json.data);
      json.data.forEach((element) => {
        if (element.id === "4ea2bad6-654f-4b75-bdf8-aae6c0e76beb")
          setReader_PersonalInfoText(element.description);
        else if (element.id === "d06b0568-96aa-47f4-90d7-ef467c1e91ad")
          setReader_FirstNameText(element.description);
        else if (element.id === "51e99a8f-4a31-47b5-a2ff-f530f3b9b2a6")
          setReader_LastNameText(element.description);
        else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
          setReader_ContinueText(element.description);
        else if (element.id === "088dcf20-c3a7-489d-83c1-9a6b8030dc21") {
          setReader_NavigatingBnPagesPleaseWait(element.description);
        } else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
          setReader_ID(element.description);
      });
    } catch (error) {}
  }
  const handlePersonalInfo = () => {
    setOpenLoader(true);
    let firstName = firstNameRef.current.value.trim();
    let lastName = lastNameRef.current.value.trim();
    if (firstName.length === 0) firstName = "";
    if (lastName.length === 0) lastName = "";
    var url = `${process.env.REACT_APP_API}/docs/read/${documentId}`;
    console.log({ ...rpdInfo, firstName, lastName });
    rpdInfo = { ...rpdInfo, firstName, lastName };
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        if (response.authenticated) {
          //setOpenLoader(false);
          console.log(documentId);
          console.log(response.recipientId);
          // setCookie(
          //   documentId,
          //   response.recipientId,
          //   response.sessionExpireDate
          // );
          setOpenLoader(false);
          window.open(response.redirectUrl, "_self");
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };

  return (
    <>
      {openLoader && (
        <LoadingSpinner authenticatingMsg={NavigatingBnPagesPleaseWait} />
      )}
      <div className="rpdFont ">
        <div
          className="rpdFont d-flex flex-column justify-content-center"
          style={{ color: "#040921" }}>
          <h1 className="text-center mb-0 mt-1 font-20px  res-font14 ">
            {personalInfoText}
          </h1>
        </div>

        <div className="rpdFont input-group mb-3 pb-2 mt-4 d-flex  justify-content-center">
          <div className="input-group-append">
            <span className="input-group-text rp-text">
              <i
                className="material-icons"
                style={{
                  fontSize: "22px",
                  color: "#ffff",
                }}>
                person
              </i>
            </span>
          </div>
          <input
            type="text"
            ref={firstNameRef}
            className="rpdFont form-control input_Person "
            placeholder={firstNameText}
            maxLength={50}
            // value={verifyEmail}

            // autoComplete="new-password"
          ></input>
        </div>
        <div className="rpdFont input-group mb-3 d-flex  justify-content-center">
          <div className="input-group-append">
            <span className="input-group-text rp-text">
              <i
                className="material-icons"
                style={{ fontSize: "22px", color: "#ffff" }}>
                person
              </i>
            </span>
          </div>
          <input
            type="text"
            ref={lastNameRef}
            className="rpdFont form-control input_Person "
            placeholder={lastNameText}
            maxLength={50}
            // value={passcode}

            //autoComplete="new-password"
          ></input>
        </div>
        <div className="rpdFont d-flex justify-content-center mt-4 pt-1 login_container">
          <button
            type="submit"
            name="button"
            className="rpdFont btn login_btn  rp-btn"
            style={{ lineHeight: "1.6", fontSize: "17px" }}
            onClick={handlePersonalInfo}>
            {continueText}
          </button>
        </div>
        <div className="rpdFont">
          <p className="rpdFont mb-0 doc-id">
            {Reader_ID} {documentId}
          </p>
        </div>
      </div>
    </>
  );
}
